import type { Control } from "react-hook-form";
import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	CryptocurrencyCreateFormInput,
	CryptocurrencyCreateFormOutput,
} from "web_myplann/Portfolio/Forms/CryptocurrencyForm/cryptocurrencyFormSchema";
import { InvestmentAdditionalFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentAdditionalFields";
import { InvestmentBasicFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentBasicFields";
import { InvestmentToolsSection } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentToolsSection";
import { InvestmentValuesSection } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentValuesSection";

type CryptocurrencyCreateFormFieldsProps = {
	control: Control<
		CryptocurrencyCreateFormInput,
		unknown,
		CryptocurrencyCreateFormOutput
	>;
};

export const CryptocurrencyCreateFormFields = ({
	control,
}: CryptocurrencyCreateFormFieldsProps) => {
	const { t } = useResource();

	return (
		<>
			<InvestmentBasicFields
				control={control}
				domain={ClientPortfolioDomainEnum.Cryptocurrencies}
				namePlaceholder={t(
					Resources.Portfolio.AddCryptocurrency.Placeholders.name,
				)}
			/>
			<InvestmentValuesSection control={control} />
			<InvestmentToolsSection control={control} />
			<InvestmentAdditionalFields control={control} />
		</>
	);
};
